// React
import React, { useEffect, useState } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Telegram UI
import { AppRoot, Accordion, Cell, Multiselectable, Section } from '@telegram-apps/telegram-ui';

// Icons
import { ReactComponent as LinkOriginalIcon } from "../assets/link_original.svg";

const tg = window.Telegram.WebApp;

const TopicsPage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, setSelectedGroup, activeView, setActiveView, premodePosts, stream, setStream }) => {
    const [activeTopics, setActiveTopics] = useState(new Set(stream.topics));
    const [topics, setTopics] = useState(selectedGroup.topics);

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        console.log('Active topics:', activeTopics);
        console.log('Type of active topics:', typeof activeTopics);
        console.log('Is array:', Array.isArray(activeTopics));
    }, [activeTopics]);

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'topics') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);


    useEffect(() => {
        const saveTopics = async () => {
            const url = 'https://api.gmpapp.ru/save_topics';

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ group_id: selectedGroup.id, topics: Array.from(activeTopics), stream_id: stream.id }),
                });

                if (!response.ok) {
                    // Здесь можно обрабатывать неуспешные коды ответов
                    console.error('Error:', response.status, response.statusText);
                } else {
                    // Если ответ успешен, можно сделать что-то с данными
                    const data = await response.json();
                    console.log('Success:', data);
                }
            } catch (error) {
                console.error('Error streams sending', error);
            }
        };

        saveTopics();
    }, [activeTopics]);

    const handleTopicToggle = (topicId) => {
        setActiveTopics(prevTopics => {
            const newTopics = new Set(prevTopics);

            if (newTopics.has(topicId)) {
                newTopics.delete(topicId);
            } else {
                newTopics.add(topicId);
            }

            const updatedTopicsArr = Array.from(newTopics);

            // Обновляем stream с новым списком топиков
            setStream(prevStream => ({
                ...prevStream,
                topics: updatedTopicsArr
            }));

            if (setSelectedGroup && selectedGroup) {
                setSelectedGroup(prevGroup => {
                    if (!prevGroup) return prevGroup;
                    const newStreams = [...prevGroup.streams];
                    const streamIdx = newStreams.findIndex(s => s.id === stream.id);
                    if (streamIdx !== -1) {
                        newStreams[streamIdx] = { ...newStreams[streamIdx], topics: updatedTopicsArr };
                    }
                    return { ...prevGroup, streams: newStreams };
                });
            }

            return newTopics;
        });
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <Section className='sectionChannelSources' header="Топики" footer="Здесь вы можете выбрать в каких топиках вашей группы будет публиковаться пост. Можно выбрать один или несколько">
                    {topics.map((topic, index) => (
                        <Cell key={topic.topic_id} Component="label" onChange={() => handleTopicToggle(topic.topic_id)} after={<Multiselectable checked={Array.from(activeTopics).includes(topic.topic_id)} name="checkbox" />} multiline>{topic.name}</Cell>
                    ))}
                </Section>
                <Section className='sectionChannelSources sectionSourceDone' style={{ marginTop: '20px' }}>
                    <Accordion className="sourceItem" expanded={isOpen} onChange={() => setIsOpen(!isOpen)}>
                        <Accordion.Summary>
                            Я не вижу своих топиков
                        </Accordion.Summary>
                        <Accordion.Content>
                            <div
                                style={{
                                    padding: '10px 20px 20px'
                                }}
                            >
                                Новые топики добавляются в раздел выше автоматически. Чтобы были видны топики, которые были созданы до добавления группы в сервис, необходимо временно изменить название топика, чтобы сервис смог зафиксировать изменение. После этого вы можете вернуть прежнее название любому из ваших топиков
                            </div>
                        </Accordion.Content>
                    </Accordion>
                </Section>
            </AppRoot>
        </div>
    );
};

export default TopicsPage;